import { ca } from '@cian/analytics';

export function trackingGoToFavoritesPage() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click_popup',
    label: 'to_favorites',
  });
}
